import { ScreenType } from '@tmdb-graphql-api/schema/types';
import { type TabItem } from '#components/Tile/types.ts';
import { BackdropSize, ImageSize } from '#enums/imageSizes.ts';
import { buildImagePath } from '#helpers/buildImagePath.ts';
import { type Config, type TrendingListing } from '#types.ts';
import { type TrendingData } from '../types.ts';

export const formatMedia = (listings: TrendingListing[], { images }: Config) =>
  listings.reduce((acc: TabItem[], data) => {
    switch (data.__typename) {
      case 'Movie': {
        acc.push({
          id: data.id,
          panelSrc: buildImagePath(data.backdropPath, ImageSize.Backdrop, BackdropSize.LG, images),
          status: data.movieStatus,
          tabSrc: buildImagePath(data.backdropPath, ImageSize.Backdrop, BackdropSize.MD, images),
          title: data.title,
          type: ScreenType.Movie,
          voteAverage: data.voteAverage,
        });

        break;
      }

      case 'Tv': {
        acc.push({
          id: data.id,
          panelSrc: buildImagePath(data.backdropPath, ImageSize.Backdrop, BackdropSize.LG, images),
          status: data.tvStatus,
          tabSrc: buildImagePath(data.backdropPath, ImageSize.Backdrop, BackdropSize.MD, images),
          title: data.name,
          type: ScreenType.Tv,
          voteAverage: data.voteAverage,
        });

        break;
      }

      // no default
    }

    return acc;
  }, []);

export const formatTrending = (data: TrendingData | null | undefined, config?: Config) => {
  if (!data || !config) {
    return [];
  }

  return formatMedia(
    data.trending.edges.map(edge => edge.node),
    config,
  );
};
